import React from "react";
import { CardView } from "../components";

export function DigitalBusinessCard() {
  return <CardView isDigitalBusinessCard={true} isDBCOnly={true} />;
}

export default DigitalBusinessCard;
